<section class="container">
  <div class="d-flex  h-full-header">
    <div class="relative d-flex flex-column gap-2 container-capped-xs container-min-xs h-100 p-2 border-left ">
      <ngx-spinner [fullScreen]="false" name="job-image-setting" type="timer" size="small"></ngx-spinner>
      <div>
        <div>کد آگهی:</div>
        <input type="number" inputmode="numeric" class="form-control" placeholder="کد آگهی" [(ngModel)]="code">
      </div>
      <div>
        <div>قالب:</div>
        <select title="template" [(ngModel)]="template" name="template">
          <option *ngFor="let tmp of templates" [value]="tmp.Id">{{tmp.Title}}</option>
        </select>
      </div>
      <div>
        <h6>آدرس تصویر پسزمینه</h6>
        <div class="d-flex p-2">
          <button class="btn btn-link btn-sm" (confirm)="clearBgUrls()">حذف لیست تصاویر</button>
        </div>
        <div class="d-flex flex-wrap gap-1 p-2">
          <img *ngFor="let bg of bgUrls" [src]="bg" class="contain rounded border" (click)="bgUrl=bg"
            style="width: 80px; height: 80px;">
        </div>
        <input type="url" dir="ltr" [(ngModel)]="bgUrl">
      </div>
      <div>
        <button class="btn btn-primary" [disabled]="!code || !template" (click)="setImageUrl()">نمایش</button>
      </div>

      <div class="flex-grow-1"></div>
      <div>
        <a class="btn btn-link m-1 col-12" routerLink="/admin/ads/image/template">مدیریت قالب ها</a>
      </div>
    </div>
    <div class="d-flex flex-column flex-grow-1 align-items-center h-100 p-2">
      <ng-container *ngIf="job">
        <div class="flex-grow-1 dark-gray-bg w-100 p-4 rounded" style="min-height: 0;">

          <img *ngIf="imageUrl" class="h-100 w-100 contain" [src]="imageUrl" style="max-width: 100%;" />

        </div>
        <div class="d-flex flex-wrap justify-content-between">
          <a class="d-none" [routerLink]="['/job',job.Id]" #link></a>
          <div class="btn btn-secondary m-1 col-12" (click)="copy(link.href)">کپی لینک به آگهی</div>
          <ng-container *ngIf="template">
            <div class="p-2">
              <a class="btn btn-secondary mx-1" [href]="html" target="_blank">HTML</a>
              <a class="btn btn-secondary mx-1" [href]="imageUrl" target="_blank">Image</a>
            </div>

          </ng-container>
        </div>
      </ng-container>

      <section class="tab-content m-1 row">
      </section>

    </div>
  </div>

</section>